// extracted by mini-css-extract-plugin
export default {"title":"ShipmentCards_title__vSWr3","divider":"ShipmentCards_divider__PZEAl"};